import { FC } from 'react';
import { Card, Fx, Icon, OptionalValue } from 'Components';
import { LineProgress, InfoTooltip } from 'Pages/Dashboard/components';
import { getProgressStatus } from 'Pages/Dashboard/Dashboard.helpers';
import { TrendIndicatorDirection } from 'Pages/Dashboard/Dashboard.types';
import { inPercent } from 'Helpers/numeric';
import styles from './StatsCard.module.scss';
import { useTranslation } from 'react-i18next';

export interface StatsCardProps {
	title: string;
	tooltip?: string;
	value?: number | null;
	trend?: number | null;
	trendDirection?: TrendIndicatorDirection | null;
	trendLabel?: string;
	onClick?: () => void;
}

const StatsCard: FC<StatsCardProps> = ({
	title,
	tooltip,
	value,
	trend,
	trendLabel = 'newDashboard.trendLabel',
	onClick
}) => {
	const status = getProgressStatus(value);
	const trendPercent = inPercent(trend) ?? 0;
    const { t } = useTranslation();

	return (
		<Card
			title={
				<Fx align="middle" style={{ gap: 6 }}>
					<span>{t(title)}</span>
					{tooltip && (
						<span className={styles.tooltipIcon}>
							<InfoTooltip title={t(tooltip)} enabled />
						</span>
					)}
				</Fx>
			}
			className={styles.root}
			headStyle={{ border: 'none' }}
			footer={
				<div className={styles.footer}>
					<div className={styles.trend}>
						{trendPercent !== null && Number(trendPercent) > 0 && (
							<Icon type="plus" className={styles.trend__icon} />
						)}
						<OptionalValue>{trendPercent || '-'}</OptionalValue>
						&nbsp;{t(trendLabel)}
					</div>

					<LineProgress percent={value} status={status} />
				</div>
			}
			onClick={onClick}
			hoverable={!!onClick}
		>
			<Fx fullHeight justify="center" column>
				<div className={styles.value}>
					<OptionalValue>{inPercent(value)}</OptionalValue>
				</div>
			</Fx>
		</Card>
	);
};

export default StatsCard;
